import {
  WalletListAPIResponse,
  WalletBalanceApiPayload,
  GetExpressOrdersByDateApiResponse,
  GetExpressSummaryOrdersByDateApiResponse,
  WalletBalanceApiResponse,
  WalletLogsApiResponse,
} from "app/types/wallets";
import { AxiosResponse } from "axios";
import axios from "./config";

export const getWalletsListApi = (
  query = ""
): Promise<AxiosResponse<WalletListAPIResponse>> =>
  axios.get<WalletListAPIResponse>(`/wallets${query}`);

export const getExpressOrdersByDateAPI = (
  clientId: number,
  selectedDate: string
): Promise<AxiosResponse<GetExpressOrdersByDateApiResponse>> =>
  axios.get<GetExpressOrdersByDateApiResponse>(
    `/clients/${clientId}/express-orders/${selectedDate}`
  );

export const getExpressSummaryOrdersByDateAPI = (
  clientId: number,
  date: string
): Promise<AxiosResponse<GetExpressSummaryOrdersByDateApiResponse>> =>
  axios.get<GetExpressSummaryOrdersByDateApiResponse>(
    `v2/clients/${clientId}/express-summary-orders?date=${date}`
  );
export const getWalletBalanceApi = (
  clientId: number
): Promise<AxiosResponse<WalletBalanceApiResponse>> =>
  axios.get<WalletBalanceApiResponse>(`/clients/${clientId}/wallets`);

export const getWalletLogsApi = (
  clientId: number,
  query: string
): Promise<AxiosResponse<WalletLogsApiResponse>> =>
  axios.get<WalletLogsApiResponse>(`/clients/${clientId}/wallet-logs${query}`);

export const updateWalletBalanceApi = (
  clientId: number,
  payload: WalletBalanceApiPayload
): Promise<AxiosResponse<WalletBalanceApiResponse>> =>
  axios.post<WalletBalanceApiResponse>(
    `/clients/${clientId}/wallet/update`,
    payload
  );
